import {LOGIN_DETAIL} from '../constants/logindetail';

const initialState = {};

const loginDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_DETAIL:
      return {
        ...state,
        loginDetail: action.payload,
      };
    default:
      return state;
  }
};
export default loginDetailReducer;
